/**
 * Normalizes a string by removing Vietnamese accents and other diacritics,
 * converting to lowercase for better search comparison.
 * 
 * @param {string} str - The string to normalize
 * @returns {string} - The normalized lowercase string
 */
export const normalizeString = (str) => {
  if (!str) return "";
  
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "d")
    .trim();
};
